$(document).ready(function(){
	var $holder_mapita = $('[data-role="svg-map-holder"]');
	var $mapita = $($holder_mapita.find('.svg-map'));

   $holder_mapita.scrollLeft(($mapita.width() - $holder_mapita.width()) / 2); 
	
	jQuery.each(jQuery('.place-tooltip'), function () {
		var $tooltip = $(this);
		var $cajita = $($holder_mapita.find($tooltip.data('ref')));

		$tooltip.css('left', ($cajita.width() - $tooltip.width()) / 2);
		$tooltip.css('transform', 'translate('+ $cajita.attr('x')+ 'px,' + $cajita.attr('y')+ 'px)');
	});

	jQuery.each(jQuery('.place-box'), function () {
		var $cajita = $(this);
				
		var $tooltip = $($holder_mapita.find('[data-ref="#'+$cajita.attr('id')+'"]'));

		$cajita.on('mouseover', function(event){
			$tooltip.addClass('active');
		}).on('mouseout', function(){
			$tooltip.removeClass('active');
		}).on('click', function(){
			$tooltip.trigger('click');
		});
	});
});